/* Version: 3.5.137 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';
import useDerivedState from '../../../hooks/useDerivedState.js';
import useId from '../../../hooks/useId.js';

var navIconAccountsIcon = (function (_ref) {
  var alt = _ref.alt,
    controlledId = _ref.id;
  var _useDerivedState = useDerivedState(useId('nav-icon-account-id-'), controlledId),
    _useDerivedState2 = _slicedToArray(_useDerivedState, 1),
    id = _useDerivedState2[0];
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    focusable: "false",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/jsx("title", {
      children: alt
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("path", {
        d: "M0 0h20v19H0z"
      })
    }), /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("g", {
        fill: "none",
        fillRule: "evenodd",
        children: /*#__PURE__*/jsx("path", {
          fill: "#FFF",
          d: "M1.928 11.334h4.944v1.322a.96.96 0 0 0 .964.955h4.33c.532 0 .965-.429.965-.955v-1.323l4.944-.01.044 5.768-16.191.043v-5.8zm16.145-1.91h-4.942V8.239a.962.962 0 0 0-.965-.956h-4.33a.96.96 0 0 0-.964.956v1.187H1.925l-.042-4.48 16.19-.044v4.524zM8.8 11.702h2.403V9.194H8.8V11.7zM7.589 1.91l4.779-.046v1.17H7.622L7.589 1.91zm10.53 1.124h-3.823v-1.17A1.877 1.877 0 0 0 12.411 0H7.589a1.876 1.876 0 0 0-1.884 1.864v1.17H1.883A1.878 1.878 0 0 0 0 4.901v12.233C0 18.164.845 19 1.883 19h16.236A1.875 1.875 0 0 0 20 17.134V4.901a1.877 1.877 0 0 0-1.881-1.867z"
        })
      }), /*#__PURE__*/jsxs("g", {
        transform: "translate(4 5.991)",
        children: [/*#__PURE__*/jsx("mask", {
          id: "".concat(id, "-mask"),
          fill: "#fff"
        }), /*#__PURE__*/jsx("path", {
          fill: "#FFF",
          d: "M-5 10.009h15v-16H-5z",
          mask: "url(#".concat(id, "-mask)")
        })]
      })]
    })]
  });
});

export { navIconAccountsIcon as default };
